import { render, staticRenderFns } from "./TaskInfo.vue?vue&type=template&id=789d3564&scoped=true"
import script from "./TaskInfo.vue?vue&type=script&lang=ts"
export * from "./TaskInfo.vue?vue&type=script&lang=ts"
import style0 from "./TaskInfo.vue?vue&type=style&index=0&id=789d3564&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d3564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('789d3564')) {
      api.createRecord('789d3564', component.options)
    } else {
      api.reload('789d3564', component.options)
    }
    module.hot.accept("./TaskInfo.vue?vue&type=template&id=789d3564&scoped=true", function () {
      api.rerender('789d3564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/TaskInfo.vue"
export default component.exports